// 引用文献静态数据（Reference.vue 使用）

// 成像仪相关文献
export const imagingDevice = [
	{
		id: '1',
		title: 'Estrogen-responsive cancer-associated fibroblasts promote invasive property of gastric cancer in a paracrine manner via CD147 production',
		journal: 'FASEB J',
		product: 'Celloger Mini Plus',
		link: 'https://faseb.onlinelibrary.wiley.com/doi/epdf/10.1096/fj.202200164RR'
	},
	{
		id: '2',
		title: 'IGFL2-AS1, A Long Non-Coding RNA, Is Associated with Radioresistance in Colorectal Cancer',
		journal: 'Int J Mol Sci',
		product: 'Celloger Mini Plus',
		link: 'https://www.mdpi.com/1422-0067/24/2/978'
	},
	{
		id: '3',
		title: 'DANGER Signals Activate G-Protein Receptor Kinases Suppressing Neutrophil Function and Predisposing to Infection After Tissue Trauma',
		journal: 'Annals of Surgery',
		product: 'Celloger Mini Plus',
		link: 'https://journals.lww.com/annalsofsurgery/abstract/2023/12000/danger_signals_activate_g_protein_receptor_kinases.52.aspx'
	},
	{
		id: '4',
		title: 'Biochemical and functional characterization of heat-inactivated coelomic fuid from earthworms as a potential alternative for fetal bovine serum in animal cell culture',
		journal: 'Scientific Reports',
		product: 'Celloger Mini Plus',
		link: 'https://www.nature.com/articles/s41598-024-56169-0'
	},
	{
		id: '5',
		title: 'Rat primary cortical cell tri-culture to study effects of amyloid-beta on microglia function',
		journal: 'bioRxiv',
		product: 'Celloger Mini Plus',
		link: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC10979983/'
	},
	{
		id: '6',
		title: 'Synergistic Effect of SiO2 and Fe3O4 Nanoparticles in Autophagy Modulation',
		journal: 'Nanomaterials (Basel) ',
		product: 'Celloger Mini Plus',
		link: 'https://www.mdpi.com/2079-4991/14/12/1033'
	},
	{
		id: '7',
		title: 'Synthesis and anti-hepatocellular carcinoma activity of aminopyridinol–sorafenib hybrids',
		journal: 'J Enzyme Inhib Med Chem ',
		product: 'Celloger Mini',
		link: 'https://www.tandfonline.com/doi/full/10.1080/14756366.2021.1953997'
	},
	{
		id: '8',
		title: '7β-22 Dihydroxyhopane, Isolated from the Sub-Antarctic Lichen, Inhibits the Viability and Stemness in Glioma Stem Like Cells',
		journal: 'Onco Targets Ther',
		product: 'Celloger Mini',
		link: 'https://www.dovepress.com/7-22-dihydroxyhopane-isolated-from-the-sub-antarctic-lichen-inhibits-t-peer-reviewed-fulltext-article-OTT'
	},
	{
		id: '9',
		title: 'Functionalized Parylene Films for Enhancement of Antibody Production by Hybridoma Cells',
		journal: 'ACS Appl Bio Mater',
		product: 'Celloger Mini',
		link: 'https://pubs.acs.org/doi/10.1021/acsabm.3c00417'
	},
	{
		id: '10',
		title: 'Effect of polystyrene nanoplastics exposure on gene expression and pathogenesis of zoonotic pathogen, Edwardsiella piscicida',
		journal: 'Ecotoxicol Environ Saf',
		product: 'Celloger Mini',
		link: 'https://www.sciencedirect.com/science/article/pii/S0147651324001325?via%3Dihub'
	},
	{
		id: '11',
		title: 'Evaluation of the role of AXL in fusion-positive pediatric rhabdomyosarcoma identifies the small-molecule inhibitor bemcentinib (BGB324) as potent chemosensitizer',
		journal: 'Mol Cancer Ther',
		product: 'Celloger Mini',
		link: 'https://aacrjournals.org/mct/article/23/6/864/745465/Evaluation-of-the-Role-of-AXL-in-Fusion-positive'
	}
]

// 计数仪相关文献
export const counterDevice = [
	{
		id: '1',
		title: 'Routine Management of Microalgae Using Autoﬂuorescence from Chlorophyll',
		journal: 'Molecules',
		product: 'FACSCOPE B',
		link: 'https://www.mdpi.com/1420-3049/24/24/4441'
	},
	{
		id: '2',
		title: 'Thrombospondin-1 counteracts the p97 inhibitor CB-5083 in colon carcinoma cells',
		journal: 'Cell Cycle',
		product: 'FACSCOPE B',
		link: 'https://www.tandfonline.com/doi/full/10.1080/15384101.2020.1754584'
	},
	{
		id: '3',
		title: 'Targeting human mitochondrial NAD(P)+-dependent malic enzyme (ME2) impairs energy metabolism and redox state and exhibits antileukemic activity in acute myeloid leukemia',
		journal: 'Cellular oncology',
		product: 'FACSCOPE B',
		link: 'https://link.springer.com/article/10.1007/s13402-023-00812-x'
	},
	{
		id: '4',
		title: 'Protocol for isolation and spectral flow cytometry analysis of immune cells from the murine exocrine and endocrine pancreas',
		journal: 'STAR protocols',
		product: 'FACSCOPE B',
		link: 'https://www.sciencedirect.com/science/article/pii/S2666166723006317?via%3Dihub'
	},
	{
		id: '5',
		title: 'Enhancing Anti-Tumor Activity of CAR T Cells Through FOXO1-Mediated Stemness and Mitochondrial Fitness',
		journal: 'Research Square (preprinting server)',
		product: 'FACSCOPE B',
		link: 'https://www.researchsquare.com/article/rs-3639314/v1'
	},
	{
		id: '6',
		title: 'The olfactory Olfr-78/ 51E2 receptor interacts with the adenosine A2A receptor. Effect of menthol and 1,8-cineole on A2A receptor-mediated signaling',
		journal: 'Frontiers in pharmacology',
		product: 'FACSCOPE B',
		link: 'https://www.frontiersin.org/journals/pharmacology/articles/10.3389/fphar.2023.1108617/full'
	},
	{
		id: '7',
		title: 'Quantitative analysis of total phenolic and flavonoid compounds in different extracts from ginger plant (Zingiber officinale) and evaluation of their anticancer effect against colorectal cancer cell lines',
		journal: 'Pharmacia',
		product: 'FACSCOPE B',
		link: 'https://pharmacia.pensoft.net/article/103936/'
	},
	{
		id: '8',
		title: 'Oleander attenuates hepatic inflammation in a TLR4-independent manner and by favorable modulation of hepatocellular global metabolome that supports cytoprotection',
		journal: 'Journal of ethnopharmacology',
		product: 'FACSCOPE B',
		link: 'https://www.sciencedirect.com/science/article/abs/pii/S0378874124000175?via%3Dihub'
	},
	{
		id: '9',
		title: 'Graphene oxide reinforced chitosan/polyvinyl alcohol antibacterial coating on stainless steel surfaces exhibit euperior bioactivity without human cell cytotoxicity',
		journal: 'Colloids and Surfaces B: Biointerfaces',
		product: 'FACSCOPE B',
		link: 'https://www.sciencedirect.com/science/article/abs/pii/S0927776523002400?via%3Dihub'
	},
	{
		id: '10',
		title: 'Identification of the functional PD-L1 interface region responsible for PD-1 binding and initiation of PD-1 signaling',
		journal: 'The Journal of biological chemistry',
		product: 'FACSCOPE B',
		link: 'https://www.jbc.org/article/S0021-9258(23)02381-5/fulltext'
	}
]
